import { useEffect } from "react";
;
var useLoadFBScript = function (_a) {
    var onScriptLoadError = _a.onScriptLoadError, onScriptLoadSuccess = _a.onScriptLoadSuccess;
    useEffect(function () {
        var script = document.createElement("script");
        script.src = "https://connect.facebook.net/en_US/sdk.js";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
        script.addEventListener("load", function () { return onScriptLoadSuccess === null || onScriptLoadSuccess === void 0 ? void 0 : onScriptLoadSuccess(); });
        script.addEventListener("error", function () { return onScriptLoadError === null || onScriptLoadError === void 0 ? void 0 : onScriptLoadError(); });
        return function () {
            document.body.removeChild(script);
        };
    }, []);
};
export default useLoadFBScript;
